export var OCCUPATION_TYPES;
(function (OCCUPATION_TYPES) {
    OCCUPATION_TYPES["EMPLOYEE"] = "EMPLOYEE";
    OCCUPATION_TYPES["WORKER"] = "WORKER";
    OCCUPATION_TYPES["OFFICER"] = "OFFICER";
    OCCUPATION_TYPES["FREELANCER"] = "FREELANCER";
    OCCUPATION_TYPES["SELF_EMPLOYED"] = "SELF_EMPLOYED";
    OCCUPATION_TYPES["RETIREE"] = "RETIREE";
    OCCUPATION_TYPES["PENSIONER"] = "PENSIONER";
    OCCUPATION_TYPES["UNEMPLOYED"] = "UNEMPLOYED";
    OCCUPATION_TYPES["HOUSEMAKER"] = "HOUSEMAKER";
})(OCCUPATION_TYPES || (OCCUPATION_TYPES = {}));
